// import { AppleStoreKitExternalLinkAccount } from "@kokotree-inc/capacitor-plugin-apple-storekit-external-link-account";// eslint-disable-next-line no-duplicate-imports
// import type { OS } from "@mantine/hooks";
import { Browser } from "@capacitor/browser";
import { Button } from "@/components/ui/button";
import {
	Drawer,
	DrawerContentWithoutCancelButton,
} from "@/components/ui/dropdownMobile";
import websiteIllustration from "../../assets/website_Illustration.png";
import type { DrawerAction, DrawerState } from "./WorkshopContentNoAuth";
import { Link } from "@tanstack/react-router";
// import { Toast } from "@capacitor/toast";

interface WorkshopModalNoAuthProps {
	drawerState: DrawerState;
	dispatch: (action: DrawerAction) => void;
	workshopType: string;
}

// TODO: Add Apple Store Kit External Link Account
// const openAcademiaWebsite = async (os: OS): Promise<void> => {

// 	if (os === "ios") {
// 		try {
// 			const result = await AppleStoreKitExternalLinkAccount.canOpen();
// 			console.log("canOpen", result);
// 			if (result.value) {
// 				// Functionality is available
// 				await Toast.show({
// 					text: "Masz włączoną opcję płatności w Apple Store",
// 					duration: "long",
// 					position: "top",
// 				});
// 				await AppleStoreKitExternalLinkAccount.open();
// 			} else {
// 				await Toast.show({
// 					text: "Aby przejść do strony Akademia LTCA, musisz mieć włączoną opcję płatności w Apple Store",
// 					duration: "long",
// 					position: "top",
// 				});
// 			}
// 		} catch {
// 			await Toast.show({
// 				text: "Błąd podczas sprawdzania opcji płatności w Apple Store",
// 				duration: "long",
// 				position: "top",
// 			});
// 		}
// 	} else {
// 		await Browser.open({ url: "https://akademialtca.pl/" });
// 	}
// };

const openAcademiaWebsite = async (): Promise<void> => {
	await Browser.open({ url: "https://akademialtca.pl/#register" });
}

export const WorkshopModalNoAuth = ({
	drawerState,
	dispatch,
	workshopType,
}: WorkshopModalNoAuthProps): JSX.Element => {
	return (
		<Drawer
			open={drawerState.open}
			onOpenChange={(open) => {
				dispatch({ type: open ? "OPEN_DRAWER" : "CLOSE_DRAWER" });
			}}
		>
			<DrawerContentWithoutCancelButton>
				<div className="m-10 text-center">
					{drawerState.step === "go_to_login" && (
						<>
							<img
								alt="website ilustration"
								className="mx-auto w-[130px] h-auto"
								src={websiteIllustration}
							/>
							<h2 className="text-xl text-[#637381] pb-4 text-center my-6">
								Czy posiadasz aktywny abonament LTCA lub masz wykupiony dostęp
								do {workshopType === "webinar" ? "webinaru" : "szkolenia"}?
							</h2>
							<div className="flex justify-around">
								<Button
									className="w-[150px] h-[50px] bg-[#919EAB14] text-black"
									onClick={() => {
										dispatch({
											type: "SET_STEP",
											payload: "go_to_website",
										});
									}}
								>
									NIE
								</Button>
								<Link to="/login">
									<Button className="w-[150px] h-[50px]">TAK</Button>
								</Link>
							</div>
						</>
					)}
					{drawerState.step === "go_to_website" && (
						<>
							{/* FIGMA VERSION */}
							{/* <h3 className="text-lg font-bold text-center mb-10">
                            Wybierz sposób dostępu do kursu
                        </h3>
                        <p className="text-[#637381] mb-10">
                            Możesz kupić dostęp do tego kursu lub wykupić abonament,
                            który daje Ci dostęp do wszystkich wydarzeń na platformie.
                        </p>
                        <p className="text-[#637381] text-center mb-2">
                            Dostęp do wszystkich wydarzeń na platformie
                        </p>
                        <Button
                            className="w-full max-w-[600px]"
                            onClick={async () => {
                                await openWorkshopSite(
                                    "https://akademialtca.pl/abonament/"
                                );
                            }}
                        >
                            Wybierz Abonament
                        </Button>
                        <p className="text-[#637381] text-center mt-6 mb-2">
                            Dostęp do wydarzenia na zawsze
                        </p>
                        <Button
                            className="w-full max-w-[600px] bg-[#919EAB14] text-black"
                            onClick={async () => {
                                await openWorkshopSite(
                                    "https://akademialtca.pl/"
                                );
                            }}
                        >
                            Kup dostęp (199 PLN + VAT)
                        </Button> */}

							<h3 className="text-lg font-bold text-center mb-10">
								Dostęp do {workshopType === "webinar" ? "webinaru" : "szkolenia"}
							</h3>
							<p className="text-[#637381] mb-10 font-semibold">
								Na stronie www Akademia LTCA możesz uzyskać dostęp do{" "}
								{workshopType === "webinar" ? "webinaru" : "szkolenia"}.
							</p>
							<ul className="w-[80%] mx-auto text-[#637381] text-left mb-10 list-disc space-y-2">
								<li className="pl-2">
									Jeżeli jesteś nowym użytkownikiem załóż konto
								</li>
								<li className="pl-2">
									W przypadku, gdy posiadasz już konto, zaloguj się i kup dostęp
									do {workshopType === "webinar" ? "webinaru" : "szkolenia"}.
								</li>
							</ul>
							<Button
								className="text-blue-700 text-lg"
								variant="link"
								// onClick={() => openAcademiaWebsite(os)}
								onClick={() => openAcademiaWebsite()}
							>
								www.akademialtca.pl
							</Button>
						</>
					)}
				</div>
			</DrawerContentWithoutCancelButton>
		</Drawer>
	);
};
